import {
  type NextAvailableStoreSlot,
  type Store,
} from '@service-initiation/shared-clients-tech-care-services';

import { type ParsedStore, type StoreAttributeAndValue } from '../types';
import { getNextAvailability } from './getNextAvailability';

export const parseStores = async (
  stores: Store[],
  calcNextAvailability?: boolean,
  filterByStoreAttributeAndValue?: StoreAttributeAndValue
): Promise<ParsedStore[]> => {
  let filteredStores = stores.filter(
    (store) =>
      !store.next_available_appointment ||
      !Array.isArray(store.next_available_appointment)
  );

  if (
    filterByStoreAttributeAndValue?.attribute !== undefined &&
    filterByStoreAttributeAndValue?.value !== undefined
  ) {
    filteredStores = filteredStores.filter((store) => {
      return (
        store.store_attributes[filterByStoreAttributeAndValue.attribute] ===
        filterByStoreAttributeAndValue.value
      );
    });
  }

  return Promise.all(
    filteredStores.map(async (store): Promise<ParsedStore> => {
      return {
        address: `${store.address_1}${store.address_2 ? ' ' : ''}${
          store.address_2
        }, ${store.city}`,
        address_1: store.address_1,
        address_2: store.address_2,
        city: store.city,
        hours: { all: store.hours.all, human: store.hours.human },
        id: store.id,
        lat: Number(store.latitude),
        lng: Number(store.longitude),
        name: store.name,
        nextAvailability: calcNextAvailability
          ? getNextAvailability(
              store.next_available_appointment as NextAvailableStoreSlot
            )
          : undefined,
        phone: store.phone,
        postal_code: store.postal_code,
        state: store.state,
        store_attributes: store.store_attributes,
        store_type: store.store_type,
        time_zone: store.time_zone,
      };
    })
  );
};
